import { Stack } from 'expo-router';
import React from 'react';

export default function RootStackLayout() {
  return (
    <Stack screenOptions={{ headerShown: false }}>
      <Stack.Screen name="nearby/index" />
      <Stack.Screen name="trending/index" />
      <Stack.Screen name="recommended/index" />
      <Stack.Screen name="cuisine/[cuisine]" />
      <Stack.Screen name="search/index" />
      <Stack.Screen name="business/[id]" />
      <Stack.Screen name="business/photos/[id]" />
      <Stack.Screen name="business/menu-items/[id]" />
      <Stack.Screen name="menu-item/[id]" />
      <Stack.Screen name="profile/[username]" />
      <Stack.Screen name="settings" />
      <Stack.Screen name="check-in" />
      <Stack.Screen name="admin" />
      <Stack.Screen name="alpha-program" />
      <Stack.Screen name="leaderboard/index" />
      <Stack.Screen name="lists/index" />
      <Stack.Screen name="lists/[id]" />
      <Stack.Screen name="terms-of-service" />
      <Stack.Screen name="privacy-policy" />
    </Stack>
  );
}
